import { Capacitor } from '@capacitor/core';

export function pickPhotoFromLibrary(
  fallbackInputRef: { current: HTMLInputElement | null },
  onDataUrl: (dataUrl: string) => void,
): void {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
    window.__NATIVE_BRIDGE__?.pickPhoto?.()
      .then(({ base64, mimeType }) => {
        onDataUrl(`data:${mimeType};base64,${base64}`);
      })
      .catch(() => {});
  } else {
    fallbackInputRef.current?.click();
  }
}
